import "@radix-ui/themes/styles.css";

import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { Theme } from "@radix-ui/themes";
import ReactDOM from "react-dom/client";

import { brand } from "./brandVariables/getBandVariables";
import { ClientPicker } from "./ClientPicker";
import { auth } from "./BE/firebaseConfig";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const handleLogin = async () => {
  const email = `${import.meta.env.VITE_TRACKER_AUTOLOGIN_EMAIL}-${
    brand.brand
  }`;
  const pass = import.meta.env.VITE_TRACKER_AUTOLOGIN_PASS;

  try {
    await signInWithEmailAndPassword(auth, email, pass);
  } catch (error: any) {
    if (error.code === "auth/user-not-found") {
      await createUserWithEmailAndPassword(auth, email, pass);
    }
  }
};

if (!auth.currentUser?.uid) {
  handleLogin();
}

if (!brand?.client) {
  // Check if client exists
  root.render(<ClientPicker />);
} else {
  root.render(
    <Theme>
      <App />
    </Theme>
  );
}
